import { Box, Grid, Paper, useTheme } from "@mui/material";
import { gridClasses, GridColDef } from "@mui/x-data-grid";
import { FC, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Agent, Permissions } from "../../api/dtos";
import GridActions from "../../components/GridActions";
import SetLinks from "../../components/layout/SetLinks";
import { StyledButton } from "../../components/StyledButton";
import CollapsibleTablePremium from "../../components/tables/CollapsibleTablePremium";
import { createCustomToolbarProps } from "../../components/utility/CustomToolbarProps";
import AgentsContext from "../../contexts/AgentsContext";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";
import useAgents from "../../hooks/data/useAgents";

const useAgentColumns = () => {

    const agentColumns = useMemo(() => {
        const columns: GridColDef<Agent>[] =  [
            {
                field: "name",
                headerName: "Name",
                flex: 1
            },
            {
                field: "actions",
                headerName: '',
                renderCell: (params) => {
                    return (
                        <GridActions
                            editPermission={Permissions.AdminAccess}
                            editUrl={`/admin/agents/edit/${params.row.id}`}
                        />
                    );
                },
                disableExport: true
            }
        ];

        return columns;
    }, []);

    return agentColumns;
}


const Agents:FC = () => {

    const columns = useAgentColumns();

    const theme = useTheme();

    const context = useAgents();
    
    const {data: agents, loading: agentsLoading} = context;
    
    const customToolbarProps = useMemo(() => createCustomToolbarProps({
        fileName: `Agents`,
        exportTitle: `Agents`,
        includeDateTime: true
    }), []);

    return (
        <AgentsContext.Provider value={context}>
            <Outlet />
            <SetLinks
                createProjectLink={DefaultProjectCreateLink}
                stageLinkEnabled={false}
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
                justifyContent={"end"}
                marginBottom={theme.spacing(2)}
            >
                <StyledButton 
                        variant="contained"
                        //@ts-expect-error
                        component={Link}
                        to={`/admin/agents/create`}
                        state={{
                            back: true
                        }}
                >
                    Add Agent
                </StyledButton>
            </Grid>
            <Paper>
                <Box
                    sx={{
                        [`& .${gridClasses.root}`]: {
                            
                            [`& .${gridClasses.columnHeader}`]: {
                                height: 'auto !important',
                                minHeight: 56,
                                
                                [`& .${gridClasses.columnHeaderTitleContainer}`]: {
                                    whiteSpace: 'normal',
                                    
                                    [`& .${gridClasses.columnHeaderTitle}`]: {
                                        whiteSpace: 'normal',
                                        paddingTop: theme.spacing(1.5),
                                        paddingBottom: theme.spacing(1.5) 
                                    }
                                },
                                
                                [`& .${gridClasses.iconButtonContainer}`]: {
                                    width: 'unset',
                                },
                                
                                '&.column-group-header': {
                                    backgroundColor: theme.palette.grey[300],
                                    boxShadow: "1",
                                    textAlign: 'center'
                                }
                            }
                        },
                    }}
                    >
                    <CollapsibleTablePremium
                        density="compact"
                        startCollapsed={false} 
                        title={"Agents"} 
                        loading={agentsLoading} 
                        columns={columns}
                        rows={agents}
                        disableColumnMenu={false}
                        disableColumnFilter={false}
                        {...customToolbarProps}
                    />
                </Box>
            </Paper>
        </AgentsContext.Provider>
    );
}

export default Agents;